import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AskQuestionsRoutingModule } from './ask-questions-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RadioButtonModule } from 'primeng/radiobutton';
import { AgentChatInputComponent } from './agent-chat-input/agent-chat-input.component';
import { AgentVoiceComponent } from './agent-voice/agent-voice.component';
import { AgentVoiceInputComponent } from './agent-voice-input/agent-voice-input.component';
import { TooltipModule } from 'primeng/tooltip';
import { AskQuestionService } from './ask-question.service';

@NgModule({
  declarations: [

  ],
  imports: [
    CommonModule,
    AskQuestionsRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    RadioButtonModule,
    AgentChatInputComponent,
    AgentVoiceComponent,
    AgentVoiceInputComponent,
    TooltipModule
  ],
  providers:[
    AskQuestionService
  ]
})
export class AskQuestionsModule { }
